'use strict';

function AddDepositController (
    $scope,
    $mdDialog,
    registries
) {
    'ngInject';

    $scope.registries = registries;

    $scope.save = function() {
        if ($scope.form.$valid) {
            $mdDialog.hide({
                amount: $scope.amount,
                comments: $scope.comments,
                registry: this.selectedRegistry
            });
        }
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };

    $scope.querySearch = function(text) {
        let matches = registries.filter(r => {
            let nameMatches = r.name.toLowerCase()
                .indexOf(text.toLowerCase()) > -1;
            return nameMatches;
        });
        return matches;
    };
}

export default AddDepositController;
